'use client';

import { IProps } from './types';

import { Link } from '@/i18n/navigation';
import BackIcon from '@/shared/assets/icons/back';
import { Center, Flex, SimpleGrid, Text } from '@chakra-ui/react';

const UniversalHeader = ({
  onBack,
  onClick,
  icon,
  backLink,
  fullTitle = false,
  title = '',
  isBackIcon,
  subtitle,
}: IProps) => {
  const BackButton = () => (
    <Center onClick={onBack}>
      <BackIcon color="var(--text-default)" />
    </Center>
  );

  return (
    <Flex
      px={4}
      color="text"
      align="center"
      minHeight="48px"
      pt="var(--tg-safe-area-inset-top)"
    >
      <SimpleGrid templateColumns="40px 1fr 40px" w="full">
        <Flex align="center">
          {isBackIcon &&
            (backLink ? (
              <Link href={backLink}>
                <BackButton />
              </Link>
            ) : (
              <BackButton />
            ))}
        </Flex>
        <Center textAlign="center" flexDir="column">
          {title && (
            <Text
              as={'h1'}
              fontWeight={700}
              lineHeight={1.2}
              fontSize={subtitle ? 'md' : 'xl'}
              lineClamp={fullTitle ? undefined : 1}
              wordBreak="break-all"
              color={'text'}
            >
              {title}
            </Text>
          )}
          {subtitle && (
            <Text mt={0.5} color="#676767" lineHeight={1.2}>
              {subtitle}
            </Text>
          )}
        </Center>
        {icon && (
          <Center justifyContent="flex-end" onClick={onClick}>
            {icon}
          </Center>
        )}
      </SimpleGrid>
    </Flex>
  );
};

export default UniversalHeader;
